import { Action, ActionCreator, createAction, props } from '@ngrx/store';
import { FilterExpression } from 'src/app/filters/filter-definition';

type ReturnType<T> = T extends (...args: any[]) => infer R ? R : any;
export type SearchProps = { searchTerm: string | null | undefined; filter?: FilterExpression | null };
export type SearchResetActionCreator = ActionCreator<string, () => Action<string>>;
export type SearchResetAction = ReturnType<SearchResetActionCreator>;
export type SearchActionCreator = ActionCreator<string, (props: SearchProps) => SearchProps & Action<string>>;
export type SearchAction = ReturnType<SearchActionCreator>;
export type LoadProps = {
   additionalFields?: string[] | null | undefined;
   urlOverride?: string;
   filterOverrides?: string[] | undefined;
   useIntermediateEmptyState?: boolean | undefined;
};
export type LoadActionCreator = ActionCreator<string, (props: LoadProps) => LoadProps & Action<string>>;
export type LoadAction = ReturnType<LoadActionCreator>;
export type LoadFromApiProps = { fields: string[]; url: string; filters?: string[] };
export type LoadFromApiActionCreator = ActionCreator<
   string,
   (props: LoadFromApiProps) => LoadFromApiProps & Action<string>
>;
export type LoadFromApiAction = ReturnType<LoadFromApiActionCreator>;
export type LoadSuccessProps<T> = { items: T[]; totalCount: number };
export type LoadFromApiSuccessProps<T> = LoadSuccessProps<T> & LoadFromApiProps;
export type LoadFromApiSuccessActionCreator<T> = ActionCreator<
   string,
   (props: LoadFromApiSuccessProps<T>) => LoadFromApiSuccessProps<T> & Action<string>
>;
export type LoadFromApiSuccessAction<T> = ReturnType<LoadFromApiSuccessActionCreator<T>>;
export type LoadFromCacheActionCreator<T> = ActionCreator<string, (props: LoadSuccessProps<T>) => Action<string>>;
export type LoadFromCacheAction<T> = ReturnType<LoadFromCacheActionCreator<T>>;
export type LoadFailureProps = { error: any };
export type LoadFailureActionCreator = ActionCreator<
   string,
   (props: LoadFailureProps) => LoadFailureProps & Action<string>
>;
export type LoadFailureAction = ReturnType<LoadFailureActionCreator>;
export type EagerSelectActions<T, TApiResult = T> = {
   search: SearchActionCreator;
   searchReset: SearchResetActionCreator;
   load: LoadActionCreator;
   loadFromCache: LoadFromCacheActionCreator<T>;
   loadFromApi: LoadFromApiActionCreator;
   loadFromApiSuccess: LoadFromApiSuccessActionCreator<TApiResult>;
   loadFromApiFailure: LoadFailureActionCreator;
};
export function createEagerSelectActions<TItem, TApiResult = TItem>(
   type: string
): EagerSelectActions<TItem, TApiResult> {
   return {
      load: createAction(type + ' Load', props<LoadProps>()),
      loadFromApi: createAction(type + ' Load From API', props<LoadFromApiProps>()),
      loadFromApiFailure: createAction(type + ' Load From API Failure', props<{ error: any }>()),
      loadFromApiSuccess: createAction(type + ' Load From API Success', props<LoadFromApiSuccessProps<TApiResult>>()),
      loadFromCache: createAction(type + ' Load From Cache', props<LoadSuccessProps<TItem>>()),
      search: createAction(type + ' Search', props<SearchProps>()),
      searchReset: createAction(type + ' Reset'),
   };
}
